module.exports = __webpack_public_path__ + "assets/img/partner7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner7.png
// module id = 1972
// module chunks = 0